import React, { useEffect, useReducer } from 'react';
import propTypes from 'prop-types';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { mostrarErro } from '@4beefopag/4bee-fopag-core/dist/molecules';
import { actions, reducer } from './reducer';
import { Wrapper, Text, Input } from '../Apontamento';
import ModalAlteracao from '../../molecules/ModalAlteracao';
import { gravarValorCadastro } from '../../../services/apontamentoProducao';

function RemuneracaoBase({ monthlyEstimate, horistaMensalista, onChange, requisicao, contratado, permiteEditar }) {
  const [state, dispatch] = useReducer(reducer, {
    editando: false,
    monthlyEstimate,
    remuneracaoBaseInicial: monthlyEstimate,
    mostrarModalConfirmacao: false,
  });

  useEffect(() => {
    dispatch({
      type: actions.reiniciarValores,
      monthlyEstimate,
    });
  }, [monthlyEstimate]);

  const alterarRemuneracaoBaseCadastro = async () => {
    dispatch({ type: actions.alterarLoading, loading: true });

    try {
      await gravarValorCadastro(requisicao, contratado, null, state.monthlyEstimate, horistaMensalista);
      dispatch({ type: actions.gravarValor, monthlyEstimate: state.monthlyEstimate });
      onChange(state.monthlyEstimate);
    } catch (err) {
      mostrarErro(err);
    } finally {
      dispatch({ type: actions.alterarLoading, loading: false });
    }
  };

  if (!state.editando) {
    return (
      <Wrapper
        onClick={() => {
          if (permiteEditar) {
            dispatch({ type: actions.editar });
          }
        }}
        disabled={!permiteEditar}
      >
        <Text
          ellipsis
          strong
        >
          {moneyFormat(state.monthlyEstimate)}
        </Text>
        {permiteEditar && <FontAwesomeIcon icon={faPencil} />}
      </Wrapper>
    );
  }

  return (
    <>
      <Input
        autoSelect
        autoFocus
        min={0}
        casasDecimais={2}
        value={state.monthlyEstimate}
        onBlur={() => dispatch({ type: actions.confirmar })}
        onPressEnter={() => dispatch({ type: actions.confirmar })}
        getValue={(valor) => {
          dispatch({
            type: actions.alterarValor,
            monthlyEstimate: valor,
          });
        }}
        disabled={!permiteEditar}
      />
      <ModalAlteracao
        titulo="Alterar remuneração base"
        visible={state.mostrarModalConfirmacao}
        onCancel={() => dispatch({ type: actions.cancelarModal })}
        onAlterarCadastro={alterarRemuneracaoBaseCadastro}
        loading={state.loading}
        corpoModal={
          <CustomText color="#a3a4a5">Tem certeza que deseja alterar a remuneração base do colaborador?</CustomText>
        }
      />
    </>
  );
}

RemuneracaoBase.propTypes = {
  monthlyEstimate: propTypes.number,
  horistaMensalista: propTypes.number.isRequired,
  onChange: propTypes.func.isRequired,
  requisicao: propTypes.number.isRequired,
  contratado: propTypes.number.isRequired,
  permiteEditar: propTypes.bool,
};

RemuneracaoBase.defaultProps = {
  monthlyEstimate: 0.0,
  permiteEditar: true,
};

export default RemuneracaoBase;
